export default __webpack_public_path__ + "image/login-background.png";